import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons';
import { faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type ReactNode, useMemo } from 'react';
import { Alert, Box } from '@mui/material';

export interface InfoBoxProps {
  content: ReactNode;
  type?: 'info' | 'danger';
}

export function InfoBox({ content, type = 'info' }: InfoBoxProps) {
  const icon: IconProp = useMemo(() => {
    switch (type) {
      case 'info':
        return faLightbulb;
      case 'danger':
        return faXmarkCircle;
      default:
        return faLightbulb;
    }
  }, [type]);

  const severity = type === 'danger' ? 'error' : 'info';

  return (
    <Alert
      severity={severity}
      icon={<FontAwesomeIcon icon={icon} style={{ fontSize: '1.2rem' }} />}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        position: 'relative',
        '& .MuiAlert-icon': {
          marginRight: 1.5,
          marginTop: 0.25,
        },
      }}
    >
      <Box sx={{ flexGrow: 1, pl: 3 }}>{content}</Box>
    </Alert>
  );
}
